export default class FantasyMultipliersModel {
  public captain: number | null = null;
  public viceCaptain: number | null = null;
}
